module.exports = __webpack_public_path__ + "img/36071-046.ef5d1ac6.jpg";